import React from 'react';
import Container6 from '../../../../assets/images/Container-6.png';

const WorkForFreeSection = () => {
  return (
    <div className="bg-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Sección Work for Free con imagen de fondo */}
        <div>
          
          {/* Contenido */}
          <div className="flex flex-col lg:flex-row items-center justify-between p-8 lg:p-12">
            {/* Lado izquierdo - Badge de garantía */}
            <img src={Container6} alt="Work for Free" className="h-full" />

            {/* Centro - Texto descriptivo */}
            <div className="text-center lg:text-left mb-6 lg:mb-0 flex-1 px-0 lg:px-4">
              <h2 className="text-3xl lg:text-4xl font-bold text-black mb-4">
                Work for Free
              </h2>
              <p className="text-black text-base lg:text-lg leading-relaxed w-full lg:max-w-2xl">
                Our 'Work for Free' guarantee gives you the confidence that Azucarai will get you front-page ranking, with selected keywords, in some of the top directories.
              </p>
            </div>

            {/* Lado derecho - Botón CTA */}
            <div className="lg:ml-8">
              <button className="bg-red-600 text-white px-8 py-4 rounded-lg font-bold text-sm lg:text-lg hover:bg-blue-700 transition-colors uppercase">
                BOOK A FREE CONSULTATION
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkForFreeSection;
